import Vue from 'vue'

import 'default-passive-events'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts'

import App from './App'
import router from './router'
import store from './store/index'
import api from './api' // 导入api接口
import './assets/manageicon/iconfont.css'
import '@/assets/font/font.css';

import moment from 'moment'; //导入模块

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn');
Vue.prototype.$moment = moment;//赋值使用
Vue.use(ElementUI);
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

Vue.prototype.$api = api; // 将api挂载到vue的原型上
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js